import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { useToast } from '@pw-tech/omni-ui';
import { getErrorMessage } from '@/modules/common/utils';
import { ApiClient } from '@pw-tech/web-sdk';

const useTrackShift = () => {
  const { toast: showToaster } = useToast();

  const { isLoading, error, mutate, mutateAsync } = useMutation(
    [API_CACHE_KEYS.TRACK_SHIFT],
    () => {
      return ApiClient.patch(API_PATHS.TRACK_SHIFT, {});
    }
  );

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error, 'Error in processing track shift..');
      showToaster({
        message: errorMessage,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error, showToaster]);

  return {
    error,
    isLoading,
    mutate,
    mutateAsync,
  };
};

export default useTrackShift;
